module.exports = __webpack_public_path__ + "assets/e9ac528e3f4238c66a30e3637203d667.png";